<template>
  <div class="app-container">
    <div class="filter-container">
      <div style="display:flex;justify-content:flex-end;align-items:center;width:100%;">
         <el-input
        v-model="listQuery.invitation_code"
        placeholder="编号"
        style="width: 200px;"
        class="filter-item"
        size="small"
        clearable
      />
        <el-input
        v-model="listQuery.name_phone"
        placeholder="用户昵称或手机号"
        style="width: 200px;"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.user_type"
        placeholder="会员"
        style="width: 120px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="非会员" :value="1" />
        <el-option label="普通会员" :value="2" />
        <el-option label="金牌代理" :value="3" />
        <el-option label="银牌代理" :value="4" />
      </el-select>


      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        style="width: 90px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="正常" :value="1" />
        <el-option label="冻结" :value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        size="small"
        @click="handleFilter"
        >搜索</el-button>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="编号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.invitation_code }}
        </template>
      </el-table-column>

      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.avatar" class="user-avatar" /> -->
           <el-avatar :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.nickname }}
        </template>
      </el-table-column>

      <el-table-column label="手机号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>

      <el-table-column label="是否会员" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag  v-if="scope.row.is_member === 0"  type="info">未开通</el-tag>
          <el-tag v-else-if="scope.row.is_agent === 1"  type="warning" >金牌会员</el-tag>
          <el-tag v-else-if="scope.row.is_agent === 2 && scope.row.is_member === 1"  type="success" >银牌会员</el-tag>
          <el-tag v-else-if="scope.row.is_member === 1" type="primary">{{scope.row.member_name}}</el-tag>
          <span v-else>后端无字段</span>
        </template>
      </el-table-column>
 
      <el-table-column label="会员到期时间" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.is_agent === 1">永久</span>
          <span v-else-if="scope.row.member_end_date">{{scope.row.member_end_date}}</span>
          <span v-else></span>
        </template>
      </el-table-column>

      <el-table-column label="余额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.wallet?scope.row.wallet.balance:0.00 }} 
        </template>
      </el-table-column>

      <el-table-column label="能量" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.chat_count }} 
        </template>
      </el-table-column>

      <el-table-column label="绘画次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.creative_num }} 
        </template>
      </el-table-column>

      <el-table-column label="文档次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.markdown_num }} 
        </template>
      </el-table-column>

      <el-table-column label="口语次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.english_chat_num }} 
        </template>
      </el-table-column>

      <el-table-column label="中文阅读次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.ai_chinese_num }} 
        </template>
      </el-table-column>

      <el-table-column label="英语报告次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.english_report_num }} 
        </template>
      </el-table-column>

      <el-table-column label="下级数量" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.parent_count }}
        </template>
      </el-table-column>

      <el-table-column label="上级昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.superior?scope.row.superior.nickname:'' }}
        </template>
      </el-table-column>

      <el-table-column label="上级手机号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.superior?scope.row.superior.phone:'' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="用户状态" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal === 1" type="primary">正常</el-tag>
          <el-tag v-else-if="scope.row.is_normal === 0" type="warning">冻结</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="created_at" label="最近登录时间" min-width="200">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.last_login_at | formatDate}}</span>
        </template>
      </el-table-column>
      
      <el-table-column align="center" prop="created_at" label="注册时间" min-width="200">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        width="330"
        class-name="small-padding fixed-width"
      >

        <template slot-scope="scope">
          
        <div class="wrapper" >
           <el-button
            v-if="scope.row.is_normal === 1"
            type="warning"
            size="mini"
            @click="handleForbid(scope.row.id, '冻结')"
            >冻结</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleForbid(scope.row.id, '解冻')"
            >解冻</el-button
          >

          <el-button
            type="primary"
            size="mini"
            @click="subordinate(scope.row.id)"
            >下级</el-button
          >

          <el-popover>
            <p>设置用户: <span style="font-weight: bold;">( {{scope.row.nickname}} )</span>为代理:</p>
            <div style="display: flex; justify-content: center;">
              <el-button type="info" size="mini" @click="handleAgent(scope.row.id, '还原普通用户',4)">初始化</el-button>
              <el-button type="warning" size="mini" @click="handleAgent(scope.row.id, '设置为金牌代理' ,1)">金牌</el-button>
              <el-button type="success" size="mini" @click="handleAgent(scope.row.id, '设置为银牌代理' ,2)">银牌</el-button>
              <el-button type="primary" size="mini" @click="Membersopen(scope.row)">普通会员</el-button>
            </div>
          <el-button style="margin-left: 10px;" size="mini" type="success" slot="reference">设置代理</el-button>
          </el-popover>

          <el-button 
          v-if="scope.row.is_agent ===  1"
            type="success"
            size="mini"
            style="margin-left: 10px;"
            @click="onAgent(scope.row)">设置代理比例
          </el-button>

          <el-button type="info"
            size="mini"
            @click="handleCode(scope.row)">查看二维码
          </el-button>

          <el-button type="primary"
            size="mini"
            style="margin-left: 10px;"
            @click="onEnergy(scope.row)">赠送能量
          </el-button>


          <el-button type="primary"
            size="mini"
            @click="onCreative(scope.row)">赠送绘画
          </el-button>

           <el-button type="primary"
            size="mini"
            @click="onEnglish(scope.row)">赠送口语
          </el-button>

          
          </div>


         <el-dialog
          title="设置月份"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"  >
          <p>注:从当前时间开始算 n代表给n个月</p>
          <p>注:会覆盖代理</p>
                
   
          <p>当前用户: </p>
          <el-input v-model="from.name" :disabled="true" >from.name</el-input>
          <p>请输入月份：</p>
          <el-input v-model="inputValue" @input="handleInput" ></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="handleAgent(from.user_id, '增加  '+ inputValue +' 个月份' ,3,inputValue)" :disabled="inputValue === ''">确定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="二维码海报"
          :visible.sync="imgDialog"
          width="30%"
          :before-close="handleCloseCode"
          >
          <el-image
            style="width: 80%; height: 80%"
            :src="url"
            >
            </el-image>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelCode">返回</el-button>
            <el-button type="primary" @click="downloadFile()" :disabled="url === ''">保存</el-button>
          </span>
        </el-dialog>

        <el-dialog title="赠送能量"   :visible.sync="showDialog" :before-close="handleClose"  >
              <el-form ref="from" :model="from" label-width="120px">
                <el-form-item label="当前用户:">
                  <el-input
                    v-model="from.name"
                    style="width: 200px"
                    :clearable="true"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>

                <el-form-item label="能量:">
                  <el-input
                    v-model="from.energy"
                    style="width: 200px"
                    :clearable="true"
                    placeholder="请输入能量"
                  >
                  </el-input>
                </el-form-item>

               

                <el-form-item style="text-align: right">
                  <el-button size="small" @click="handleCancel">返回</el-button>

                  <el-button
                    size="small"
                    @click="handleSubmit"
                    type="primary"
                    :disabled="!from.energy"
                    
                    >提交</el-button
                  >
                   <!-- :loading="btnLoading" -->
              </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="赠送口语次数"   :visible.sync="englishDialog" :before-close="handleClose"  >
              <el-form ref="from" :model="from" label-width="120px">
                <el-form-item label="当前用户:">
                  <el-input
                    v-model="from.name"
                    style="width: 200px"
                    :clearable="true"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>

                <el-form-item label="次数:">
                  <el-input
                    v-model="from.english_num"
                    style="width: 200px"
                    :clearable="true"
                    placeholder="请输入次数"
                  >
                  </el-input>
                </el-form-item>

                <el-form-item style="text-align: right">
                  <el-button size="small" @click="handleCancel">返回</el-button>

                  <el-button
                    size="small"
                    @click="handleEnglishSubmit"
                    type="primary"
                    :disabled="!from.english_num"
                    >提交</el-button
                  >
                   <!-- :loading="btnLoading" -->
              </el-form-item>
            </el-form>
        </el-dialog>
  
        <el-dialog title="设置代理比率"   :visible.sync="agentDialog" :before-close="handleClose"  >
              <el-form ref="from" :model="from" label-width="120px">
                <el-form-item label="当前用户:">
                  <el-input
                    v-model="from.name"
                    style="width: 200px"
                    :clearable="true"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
                <p> , 分隔符 例子:  0.3,0.2,0,1</p>
                <el-form-item label="比例:">
                  <el-input
                    v-model="from.userProportion"
                    style="width: 200px"
                    :clearable="true"
                    placeholder="请输入比例"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item style="text-align: right">
                  <el-button size="small" @click="handleCancel">返回</el-button>

                  <el-button
                    size="small"
                    @click="agentSubmit"
                    type="primary"
                    
                    >提交</el-button
                  >
                   <!-- :loading="btnLoading" -->
              </el-form-item>
            </el-form>
      </el-dialog>


        <el-dialog title="赠送绘画次数"   :visible.sync="creativeDialog" :before-close="handleClose"  >
              <el-form ref="from" :model="from" label-width="120px">
                <el-form-item label="当前用户:">
                  <el-input
                    v-model="from.name"
                    style="width: 200px"
                    :clearable="true"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>

                <el-form-item label="次数:">
                  <el-input
                    v-model="from.creative"
                    style="width: 200px"
                    :clearable="true"
                    placeholder="请输入绘画次数"
                  >
                  </el-input>
                </el-form-item>

                <el-form-item style="text-align: right">
                  <el-button size="small" @click="handleCancel">返回</el-button>

                  <el-button
                    size="small"
                    @click="handleCreativeSubmit"
                    type="primary"
                    :disabled="!from.creative"
                    
                    >提交</el-button
                  >
                   <!-- :loading="btnLoading" -->
              </el-form-item>
            </el-form>
        </el-dialog>


        </template>
        
      </el-table-column>

     
     

      
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
    ,formatDate: function(value) {
      var date = new Date(value * 1000); // 将时间戳转换为毫秒
      return date.toLocaleString(); // 返回本地化的日期和时间字符串
    }
  },

  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        name_phone: '',
        is_normal: "",
        user_type: ""
      },
      from:
      {
        user_id:"",
        name:"",
        energy:'',
        creative:'',
        userProportion:'',
        english_num:'',
      },
      dialogVisible : false,
      imgDialog : false,
      inputValue: 2,
      Energy: '',
      showDialog:false,
      creativeDialog:false,
      englishDialog:false,
      agentDialog:false,
      url:''
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/user/index",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true, // 显示取消按钮
        center: true // 对话框内容居中显示
      })
        .then(() => {
          request({
            url: "/api/backend/user/is_normal",
            method: "post",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleAgent(val, text ,type ,inputValue) {
      this.$confirm("此操作将用户" + text + " 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        // showCancelButton: true, // 显示取消按钮
        center: true // 对话框内容居中显示
      })
        .then(() => {
          console.log(val, text ,type ,inputValue);
          request({
            url: "/api/backend/user/is_agent",
            method: "post",
            params: { 
              user_id: val ,
              type : type ,
              month: inputValue
            }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.dialogVisible = false;
            this.inputValue = 2;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },

    handleCloseCode(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.imgDialog = false;
          this.url = '';
        })
        .catch(_ => {});
    },
    cancel() {
      this.dialogVisible = false;
      },
    Membersopen(data) {
      this.dialogVisible =true;
      this.from={
      user_id:data.id,
      name:data.nickname
      };
    
      },
    handleInput() {
          // 去除非数字字符
          this.inputValue = this.inputValue.replace(/\D/g, "");
    },

   //他的下级
    subordinate(parent_id)
    {
        this.$router.push({path:'/user/subordinate',query:{parent_id}});
      // this.$router.push('/find/index_two/?up_id=' + row.id +'&up_name=' + row.name)
    },

    onEnergy(data) {
      this.showDialog = true;
      this.from={
      user_id:data.id,
      name:data.nickname
      };
    },

    onAgent(data) {
      this.agentDialog = true;
      this.from={
      user_id:data.id,
      name:data.nickname,
      userProportion:data.agent_proportion
      };
    },

    onCreative(data) {
      this.creativeDialog = true;
      this.from={
        user_id:data.id,
        name:data.nickname
      };
    },

    onEnglish(data) {
      this.englishDialog = true;
      this.from={
        user_id:data.id,
        name:data.nickname
      };
    },
    

    handleCancel() {
      this.showDialog = false;
      this.creativeDialog = false;
      this.englishDialog = false;
      this.agentDialog = false;

    },

    agentSubmit() {
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          request({
            url: "/api/backend/user/userProportion",
            method: "post",
            data: this.from,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.agentDialog = false;
              this.getList(); 
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.btnLoading = false;
              this.agentDialog = false;
              this.showDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.btnLoading = false;
        });
    },

    handleSubmit() {
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          request({
            url: "/api/backend/user/getEnergy",
            method: "post",
            data: this.from,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.btnLoading = false;
              this.showDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.btnLoading = false;
        });
    },

    handleEnglishSubmit() {
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          request({
            url: "/api/backend/user/getEnglish",
            method: "post",
            data: this.from,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.englishDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.englishDialog = false;
        });
    },


    handleCreativeSubmit() {
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          request({
            url: "/api/backend/user/getCreative",
            method: "post",
            data: this.from,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.creativeDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.creativeDialog = false;

        });
    },

    handleCode(row) {
      this.imgDialog = true;
      this.from.name = row.nickname;
      request({
        url: "/api/backend/user/wxMiniCode",
        method: "get",
        params: {
          user_id:row.id}
      }).then(response => {
        this.url = response.data
      });
    },

    cancelCode()
    {
      this.imgDialog = false;
      this.url = '';
    },
    downloadFile() {
      let fileUrl = this.url;
      let fileName = '用户: ' + this.from.name;
      
      const xhr = new XMLHttpRequest();

      // Open a GET request to the file URL
      xhr.open('GET', fileUrl, true);

      // Set the response type to 'blob'
      xhr.responseType = 'blob';

      // When the request is complete
      xhr.onload = function() {
        // Convert the response to a Blob object
        const blob = new Blob([this.response], { type: 'image/jpeg' });

        // Create a temporary link element
        const link = document.createElement('a');

        // Set the href attribute to the Blob object URL
        link.href = URL.createObjectURL(blob);

        // Set the download attribute to force download with the desired file name
        link.setAttribute('download', fileName);

        // Append the link to the document body
        document.body.appendChild(link);

        // Click the link to trigger the download
        link.click();

        // Remove the link from the document body after download
        document.body.removeChild(link);
      };

      // Send the request
      xhr.send();
      this.imgDialog = false;
      this.url = '';
    }



  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

.wrapper > button{
  margin-bottom:.25rem;
}
</style>
